import React from 'react'
import dayjs from 'dayjs'
import { VacancesType } from '../../../api/Absence/types'
import {View, Views} from 'react-big-calendar'
import { MarkedDates } from 'react-native-calendars/src/types'

export default function DateCellWrapper({date, vacances, view, markedDates}: DateCellWrapperProps) {
  const dateKey = dayjs(date).format('YYYY-MM-DD')
  const markedDate = markedDates?.[dateKey]
  
  const conteneurStyle: React.CSSProperties = {
    width: '100%', 
    height: '100%', 
    backgroundColor: markedDate?.color || 'transparent'
  }
  
  return (
    <div style={conteneurStyle} data-testid={`BT_${dateKey}`}>
      <div style={{
        width: '100%',
        height: view !== Views.MONTH
          ? '100%'
          : 13,
        display:'flex',
        flexDirection: 'column',
        justifyContent: view!==Views.MONTH
          ? 'space-around'
          : 'space-between'
      }}>
        {vacances.filter((vacance) => (vacance.selected)).map((vacance, index) => 
          (<div key={index} style={{backgroundColor: vacance.jours.some((day) => day.isSame(date, 'day')) ? vacance.couleur : 'inherit', height:3, width: '100%'}} />)
        )}
      </div>
    </div>
  )
}

type DateCellWrapperProps = {
  date: Date;
  vacances: VacancesType[];
  view?: View;
  markedDates?: MarkedDates;
}